<header #header id="cx-header" cxSkipLink="cx-header">
  <div class="top-header" id="top-header" [ngClass]="{ 'loggedIn topHeader-sm': isLoggedIn }">
    <div class="container">
      @if (isCheckoutPage && isLoggedIn) {
      @if (isCustSelector) {
      <div class="customer-id-checkOut">
        <a (click)="showContent = !showContent">
          <div>
            {{'common.header_customer_id'|cxTranslate}}
            <span>
              {{ currentOne?.salesArea1 }}&nbsp;|&nbsp;
              {{ currentOne?.salesArea2 ? (currentOne?.salesArea2 | cxTranslate) : ''
              }}&nbsp;|&nbsp;&nbsp;|&nbsp;
              {{ currentOne?.salesArea3 }}
            </span>
          </div>&nbsp;
          @if (options?.length > 1) {
          <img src="{{ showContent ? '/icons/arrows_up_blue.svg' : '/icons/arrow_down_blue.svg'}}" class="icon-right"
            alt="">
          }
        </a>
      </div>
      }
      } @else {
      <div class="left-side-content d-none d-lg-block">
        <ng-container *ngTemplateOutlet="customerIdDropDown"></ng-container>
      </div>
      <div class="right-side-content">
        @if (isLoggedIn) {
        <span class="user-name">
          {{ 'common.header_welcome' | cxTranslate }}
          {{ firstname | uppercase }} {{ lastname | uppercase }}
        </span>
        }
        <cx-page-slot [ngClass]="isLoggedIn?'loggedIn':'loggedOut'" position="KbHeaderLinks"></cx-page-slot>
      </div>
      <div class="d-block d-lg-none">
        <ng-container *ngTemplateOutlet="customerIdDropDown"></ng-container>
      </div>
      }
    </div>
    @if (signalShow) {
    <div class="top-header signal-msg">
      <span class="signal-msg-span" [innerHTML]="signalMsg"></span>
    </div>
    }
    @if (options?.length > 1) {
    <app-customer-id [show]="showContent" [arrData]="options" (childValueChange)="onChildValueChange($event)"
      [current]="currentOne"></app-customer-id>
    }
  </div>

  @if (currentUrl.includes('/qa')) {
  <div class="top-header" style="text-align: center" [ngClass]="{ 'loggedIn testTextLogged': isLoggedIn }">
    <span class="testText"> S1 – FOR TEST USAGE ONLY </span>
  </div>
  }
  <div class="bottom-header">
    <div class="container">
      <div class="header-container">
        <button class="toggle-menu d-block d-md-block d-lg-none" (click)="mobileNav()">
          <img [attr.src]="
              mobileNavToggle
                ? '/icons/close-kb.svg'
                : '/images/icon-menu.png'
            " alt="" class="burgur_icon" />
        </button>
        <cx-page-slot position="SiteLogo"></cx-page-slot>
        <cx-page-slot position="SearchBox" class="d-none d-md-none d-lg-block"></cx-page-slot>
        @if (isLoggedIn) {
        <cx-page-slot [ngClass]="isLoggedIn ? 'loggedIn' : 'loggedOutHider'" position="MiniCart" class="hidden-mobile ">
        </cx-page-slot>
        }
        <ng-container>
          <app-kb-header-language></app-kb-header-language>
          <app-kb-country-flag></app-kb-country-flag>
          @if (isLoggedIn) {
          <div class="d-block d-md-block d-lg-none">
            <app-kb-notifications></app-kb-notifications>
          </div>
          }
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mb-menu d-md-block d-lg-none">
    <ul>
      <li class="item-left">
        <a href="/enduraSurePro/visitor-information" class="kb-calc">
          <img src="/images/kb-calculator.png" alt="" class="calculator-icon" width="20" height="20" />
        </a>
      </li>
      <li class="item-left" (click)="showMyAccountTab()">
        <img src="/icons/user-icon-blue.svg" alt="" class="user-icon" />
      </li>
      <li class="item-left">
        <a href="/US/en/USD/storefinder">
          <img src="/icons/location-icon.svg" alt="" class="location-icon" />
        </a>
      </li>
      <li class="item-right">
        <span (click)="showSearch = !showSearch">
          <img src="/icons/search-icon-blue.svg" alt="" class="search-icon" width="20" height="20" />
        </span>
      </li>
      <li class="item-right-end hidden-desktop">
        <cx-page-slot [ngClass]="isLoggedIn ? 'loggedIn' : 'loggedOutHider'" position="MiniCart"></cx-page-slot>
      </li>
    </ul>
  </div>
  @if (mobileNavToggle) {
  <div class="bottom-lower-header d-block d-md-block d-lg-none">
    <cx-page-slot position="NavigationBar"></cx-page-slot>
  </div>
  }
  @if (showSearch) {
  <div class="mobileSearch">
    <cx-page-slot position="SearchBox"></cx-page-slot>
  </div>
  }
  <div class="bottom-lower-header d-none d-md-none d-lg-block">
    <cx-page-slot position="NavigationBar"></cx-page-slot>
  </div>
  <cx-breadcrumb [ngClass]="{'mob-view':disableMobBreadcrumb === false}"></cx-breadcrumb>

  <cx-page-slot position="BottomHeaderSlot"></cx-page-slot>
  <cx-global-message aria-atomic="true" aria-live="assertive"></cx-global-message>
  @if (showMyAcc) {
  <app-my-account-left-sidenav></app-my-account-left-sidenav>
  }
</header>

@if (scrollableHeader) {
<app-kb-scrollableheader></app-kb-scrollableheader>
}

<ng-template #customerIdDropDown>
  @if (isCustSelector && isLoggedIn) {
  <div class="customer-id">
    <a (click)="showContent = !showContent">
      @if (custIDService.theCurrentCustomerIdState$|async; as currentCustomer ) {
      <div>
        {{'common.header_customer_id'|cxTranslate}}<span>
          {{ currentCustomer?.salesArea1 }}&nbsp;|&nbsp;
          {{ currentCustomer?.salesArea2 ? (currentCustomer?.salesArea2 | cxTranslate) : ''
          }}&nbsp;|&nbsp;
          {{ currentCustomer?.salesArea3 }}</span>
      </div>
      }&nbsp;
      @if (options?.length > 1) {
      <img src="{{ showContent ? '/icons/arrows_up_blue.svg' : '/icons/arrow_down_blue.svg'}}" class="icon-right"
        alt="">
      }
    </a>
  </div>
  }
</ng-template>